import {z} from "zod";
import {BookingDuration} from "@/lib/enum/BookingDuration.ts";
import {zPhoneRequired} from "@/lib/validate/PhoneValidate.ts";
import {BookingKind} from "@/lib/enum/BookingKind.ts";

export const BookingFormSchema = z.object({
    firstName: z.string().min(2, {
        message: "First name must be at least 2 characters.",
    }),
    lastName: z.string().min(2, {
        message: "Last name must be at least 2 characters.",
    }),
    email: z.string().email({
        message: "Please enter a valid email address.",
    }),
    phone: zPhoneRequired,
    businessName: z.string().optional(),
    poNumber: z.string().optional(),

    duration: z.nativeEnum(BookingDuration, {
        required_error: "Please select a duration.",
    }),
    startDate: z.date({
        required_error: "Please select a drop off date.",
    }),
    endDate: z.date({
        required_error: "Please select a pickup date.",
    }),

    binKind: z.nativeEnum(BookingKind, {
        required_error: "Please select a duration.",
    }),
    binSize: z.string({
        required_error: "Please select a bin size.",
    }),
    binType: z.string({
        required_error: "Please select a bin type.",
    }),
    extras: z.record(z.string(), z.preprocess((x) => (x ? x : undefined), z.coerce.number().int().min(0).max(31).optional())),

    address: z.string({
        required_error: "Please enter an address.",
    }),
    suburb: z.string(),
    postcode: z.string(),
    state: z.string(),
    lat: z.number(),
    lng: z.number(),
    distanceCharge: z.number().nullable(),
    notes: z.string({
        required_error: "Please tell us where you would like the bin placed.",
    }),

    terms: z.boolean({ required_error: "Please agree to the terms and conditions." }).refine(value => value, {
        message: "Please agree to the terms and conditions.",
    }),
    allowPromo: z.boolean().optional(),

    commDepartment: z.string().optional(),
    commCaseName: z.string().optional(),
    commCaseEmail: z.string().optional(),
    commCasePhone: z.string().optional(),
    commInvoiceEmail: z.string().optional(),
    commPurchaseOrder: z.string().optional(),
});
